import { render, staticRenderFns } from "./constitution.vue?vue&type=template&id=4dcd29f2&scoped=true&"
import script from "./constitution.vue?vue&type=script&lang=js&"
export * from "./constitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd29f2",
  null
  
)

export default component.exports